import { render, staticRenderFns } from "./TeamMiniCard.vue?vue&type=template&id=fadadd66&scoped=true&"
import script from "./TeamMiniCard.vue?vue&type=script&lang=ts&"
export * from "./TeamMiniCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMiniCard.vue?vue&type=style&index=0&id=fadadd66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadadd66",
  null
  
)

export default component.exports